import { use } from 'react'

import { MallLayoutContext } from '../context'

export const useMallLayout = () => {
  const context = use(MallLayoutContext)

  if (!context) {
    throw new Error('useMallLayout must be used within a MallLayoutProvider')
  }

  return context
}
